var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9.816,
    y1: 9.871,
    x2: 41.246,
    y2: 41.301,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.012,34.56c-0.439,2.24 -2.304,3.947 -4.608,4.267c-3.621,0.533 -9.656,1.173 -16.459,1.173c-6.693,0 -12.728,-0.64 -16.459,-1.173c-2.304,-0.32 -4.17,-2.027 -4.608,-4.267c-0.439,-2.453 -0.878,-6.08 -0.878,-10.56c0,-4.48 0.439,-8.107 0.878,-10.56c0.439,-2.24 2.304,-3.947 4.608,-4.267c3.621,-0.533 9.656,-1.173 16.459,-1.173c6.803,0 12.728,0.64 16.459,1.173c2.304,0.32 4.17,2.027 4.608,4.267c0.439,2.453 0.988,6.08 0.988,10.56c-0.11,4.48 -0.549,8.107 -0.988,10.56z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.352,22.44l-11.436,-7.624c-0.577,-0.385 -1.314,-0.421 -1.925,-0.093c-0.611,0.327 -0.991,0.96 -0.991,1.653v15.248c0,0.693 0.38,1.327 0.991,1.654c0.278,0.149 0.581,0.222 0.884,0.222c0.364,0 0.726,-0.106 1.04,-0.315l11.436,-7.624c0.523,-0.349 0.835,-0.932 0.835,-1.56c0.001,-0.629 -0.312,-1.212 -0.834,-1.561z",
    fill: "#000000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.681,15.237l10.79,7.194c0.689,0.495 1.153,0.938 1.153,1.513c0,0.575 -0.224,0.976 -0.715,1.334c-0.371,0.27 -11.045,7.364 -11.045,7.364c-0.901,0.604 -2.364,0.476 -2.364,-1.499v-14.399c0,-2.005 1.584,-1.905 2.181,-1.507z",
    fill: "#000000",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,31.568v-15.135c0,-0.743 0.828,-1.187 1.447,-0.774l11.352,7.568c0.553,0.368 0.553,1.18 0,1.549l-11.352,7.568c-0.619,0.411 -1.447,-0.032 -1.447,-0.776z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6ba50891d5d64380c8c2b26281444b58.svg";
export { ForwardRef as ReactComponent };